module.exports = __webpack_public_path__ + "assets/8cf3ad23f628a7891d50af462f81372b.svg";